import { useCallback, useEffect, useState } from "react";
import { chatApi } from "../../lib/api";

// Debounced live search across the caller's own conversations (channel/DM
// names + message content). Shared by both the mobile and desktop Messages
// pages so the behavior (debounce timing, empty/loading states) stays identical.
export function useChatSearch(query) {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const runNow = useCallback(async (term) => {
    const t = (term || "").trim();
    if (t.length < 2) return;
    setLoading(true);
    try {
      const data = await chatApi.search(t);
      setResults(data || []);
      setOpen(true);
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const term = (query || "").trim();
    if (term.length < 2) {
      setResults([]);
      setOpen(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const data = await chatApi.search(term);
        setResults(data || []);
        setOpen(true);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [query]);

  return { results, open, setOpen, loading, runNow };
}
